import React, {Fragment} from "react";

const PageContainer = (props) => (
    <div className={`pageContainer ${props.className || ''}`} style={props.style}>
        {props.children}
    </div>
)

export default PageContainer;
